// extracted by mini-css-extract-plugin
module.exports = {"container":"CartAdditionalTermsInfo_container__ZRIXK"};